export const SET_LOADING = 'SET_LOADING';
export const LOADER_SCOPES = {
    SITE: 'siteLoading',
};